import { APICallV3Post } from 'reactApp/api/APICall';

type SubscriptionRenewResponse = { pw: string };

export class SubscriptionRenewAPICall extends APICallV3Post<SubscriptionRenewResponse> {
    _method = 'billing/subscription/renew';
}
